import { useFm } from '@web3/base-hooks';
import { Image, Button, TextLink } from '@bfe/moly';
import { appPath } from '@web3/base-utils';
import cls from 'classnames';

import styles from './style.module.scss';

interface IProps {
  beginShare: () => void;
  title: string;
}

export const ShareCard = ({ beginShare, title }: IProps) => {
  const fm = useFm();

  return (
    <div
      className={cls(
        'gradient-border',
        styles.moduleMarginTop,
        styles.gradientBorder
      )}
    >
      <div className={styles.wrap}>
        <Image
          src={`${appPath}/png/profile/border-lf.png`}
          className={styles.bgLf}
          alt=""
        />
        <div className={styles.main}>
          <Image
            src={'/bybit/deadpool/image-3ce3564979d74fabb5340acc16585d32.png'}
            className={styles.logo}
            alt=""
          />

          <h1 className={cls('text-center', styles.title)}>{title}</h1>

          <Button
            size="x-large"
            className={cls(styles.btn, 'contained-btn')}
            onClick={beginShare}
          >
            <TextLink variant="secondary" size="xlarge" color="#1E2023">
              {fm('shareWsotIdol')}
            </TextLink>
          </Button>
        </div>
        <Image
          src={`${appPath}/png/profile/border-rt.png`}
          className={styles.bgRt}
          alt=""
        />
      </div>
    </div>
  );
};
